// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityDetailPPTX from '../../../containers/analytics/pptx/SecurityDetailPPTX';


const SecurityNonCriticalInadequateDetailPPTX = ({ data }) => {
  return (
    <SecurityDetailPPTX
      data={data}
      criticality='nonCritical'
      adequacy='inadequate'
    />
  );
};

SecurityNonCriticalInadequateDetailPPTX.propTypes = {
  data: PropTypes.object
};

export default SecurityNonCriticalInadequateDetailPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/SecurityNonCriticalInadequateDetailPPTX.js